import { Progress } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SearchProgressBar: FC<{ isPollingDone: boolean }> = ({ isPollingDone }) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (isPollingDone) {
      setProgress(100);
      const t = setTimeout(() => setVisible(false), 800);
      return () => clearTimeout(t);
    }

    setVisible(true);
    setProgress(0);
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) return prev;
        return prev + (90 - prev) * 0.025; // easing: decelerates as it approaches 90
      });
    }, 100);
    return () => clearInterval(interval);
  }, [isPollingDone]);

  if (!visible) return null;

  return (
    <div className="w-full px-4">
      <Progress
        percent={Number(progress.toFixed(1))}
        showInfo={false}
        strokeColor="var(--color-primary-60)"
        status={isPollingDone ? "success" : "active"}
      />
    </div>
  );
};

export default SearchProgressBar;
